export default "__VITE_ASSET__DZD6jERn__"